jQuery(document).ready(function($){

    $('a[href="#search"]').click(function(event) {
        event.preventDefault();
        $('#modal-search').foundation('open');
    });

    $('.header__box [data-close]').click(function() {
        localStorage.setItem('ue_closed', 1);
    });

    if (localStorage.getItem('ue_closed') == 1) {
        $('.header__box').hide();
    }

});
